/* eslint-disable */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
    Grid,
    MenuItem,
    Paper,
    CardContent,
    Typography,
    Box,
    Fade,
    FormControlLabel,
    Checkbox,
    Button
} from '@mui/material';
import {
    Code,
    Add,
    Business,
    Edit as EditIcon,
    Save as SaveIcon,
    Cancel as CancelIcon
} from '@mui/icons-material';
import { useProjectCode } from 'hooks/api/terminology/project-code/useProjectCode';
import { AnimatedButton, StyledCard, StyledTextField, globalColor } from '../../ConstantColors';
import { logger } from 'utils/environment/log';
import Swal from 'sweetalert2';

const AddEditProjectCode = ({ editingProjectCode, onProjectCodeSubmitted, branchCodes }) => {
    const [formData, setFormData] = useState({
        name: '',
        code: '',
        description: '',
        isActive: true,
        effectiveFrom: new Date().toISOString().split('T')[0],
        effectiveTo: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
        totalBudget: 0,
        remainingBudget: 0,
        branchCode: {
            id: ''
        }
    });

    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    const { createProjectCode, updateProjectCode } = useProjectCode();

    // Initialize form data when editing
    useEffect(() => {
        if (editingProjectCode) {
            setFormData({
                name: editingProjectCode.name || '',
                code: editingProjectCode.code || '',
                description: editingProjectCode.description || '',
                isActive: editingProjectCode.isActive !== undefined ? editingProjectCode.isActive : true,
                effectiveFrom: editingProjectCode.effectiveFrom 
                    ? new Date(editingProjectCode.effectiveFrom).toISOString().split('T')[0]
                    : new Date().toISOString().split('T')[0],
                effectiveTo: editingProjectCode.effectiveTo 
                    ? new Date(editingProjectCode.effectiveTo).toISOString().split('T')[0]
                    : new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
                totalBudget: editingProjectCode.totalBudget || 0,
                remainingBudget: editingProjectCode.remainingBudget || 0,
                branchCode: {
                    id: editingProjectCode.branchCode?.id || ''
                }
            });
        } else {
            // Reset form for new project code
            setFormData({
                name: '',
                code: '',
                description: '',
                isActive: true,
                effectiveFrom: new Date().toISOString().split('T')[0],
                effectiveTo: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
                totalBudget: 0,
                remainingBudget: 0,
                branchCode: {
                    id: ''
                }
            });
        }
        setErrors({});
    }, [editingProjectCode]);

    const validateForm = () => {
        const newErrors = {};
        
        if (!formData.name.trim()) {
            newErrors.name = 'Project name is required';
        }
        
        if (!formData.code.trim()) {
            newErrors.code = 'Project code is required';
        }

        if (!formData.description.trim()) {
            newErrors.description = 'Description is required';
        }

        if (!formData.branchCode.id) {
            newErrors.branchCode = 'Branch code is required';
        }

        // Validate dates
        if (formData.effectiveFrom && formData.effectiveTo) {
            const fromDate = new Date(formData.effectiveFrom);
            const toDate = new Date(formData.effectiveTo);
            
            if (fromDate >= toDate) {
                newErrors.effectiveTo = 'Effective To date must be later than Effective From date';
            }
        }

        // Validate budget values
        if (formData.totalBudget < 0) {
            newErrors.totalBudget = 'Total budget cannot be negative';
        }

        if (formData.remainingBudget < 0) {
            newErrors.remainingBudget = 'Remaining budget cannot be negative';
        }

        if (formData.remainingBudget > formData.totalBudget) {
            newErrors.remainingBudget = 'Remaining budget cannot exceed total budget';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;
        
        if (name.includes('.')) {
            const [parent, child] = name.split('.');
            setFormData((prev) => ({
                ...prev,
                [parent]: {
                    ...prev[parent],
                    [child]: value
                }
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: type === 'checkbox' ? checked : value
            }));
        }

        // Clear error when user starts typing
        if (errors[name] || errors[name?.split('.')[1]]) {
            setErrors(prev => ({
                ...prev,
                [name]: '',
                [name?.split('.')[1]]: ''
            }));
        }
    };

    const handleSubmit = async () => {
        if (!validateForm()) {
            Swal.fire({
                icon: 'error',
                title: 'Validation Error',
                text: 'Please fill in all required fields correctly.'
            });
            return;
        }

        setLoading(true);
        try {
            // Prepare data for submission
            const submitData = {
                ...formData,
                totalBudget: Number(formData.totalBudget),
                remainingBudget: Number(formData.remainingBudget),
                effectiveFrom: new Date(formData.effectiveFrom).toISOString(),
                effectiveTo: new Date(formData.effectiveTo).toISOString()
            };

            if (editingProjectCode) {
                await updateProjectCode(editingProjectCode.id, submitData);
                Swal.fire({
                    icon: 'success',
                    title: 'Project Code Updated',
                    text: 'The project code has been successfully updated.',
                    showConfirmButton: false,
                    timer: 1500
                });
            } else {
                await createProjectCode(submitData);
                Swal.fire({
                    icon: 'success',
                    title: 'Project Code Created',
                    text: 'The project code has been successfully created.',
                    showConfirmButton: false,
                    timer: 1500
                });
            }
            onProjectCodeSubmitted();
        } catch (error) {
            logger.error('Error saving project code:', error);
            
            let errorMessage = `Failed to ${editingProjectCode ? 'update' : 'create'} the project code. Please try again.`;
            if (error.response && error.response.data && error.response.data.message) {
                errorMessage = error.response.data.message;
            }

            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: errorMessage
            });
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        onProjectCodeSubmitted();
    };

    const getSelectedBranchCode = () => {
        return branchCodes.find(bc => bc.id === formData.branchCode.id || bc.branchCodeId === formData.branchCode.id);
    };

    return (
        <Fade in timeout={1000}>
            <StyledCard elevation={0}>
                <CardContent>
                    <Typography
                        variant="h5"
                        gutterBottom
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            color: globalColor,
                            fontWeight: 'bold',
                            mb: 4
                        }}
                    >
                        <Code /> {editingProjectCode ? 'Edit Project Code' : 'Add New Project Code'}
                    </Typography>

                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <StyledTextField
                                select
                                fullWidth
                                name="branchCode.id"
                                label="Branch Code *"
                                value={formData.branchCode.id}
                                onChange={handleChange}
                                variant="outlined"
                                error={!!errors.branchCode}
                                helperText={errors.branchCode}
                                disabled={loading}
                                InputProps={{
                                    startAdornment: (
                                        <Box sx={{ mr: 1, color: globalColor }}>
                                            <Business fontSize="small" />
                                        </Box>
                                    )
                                }}
                            >
                                <MenuItem value="">
                                    <em>Select Branch Code</em>
                                </MenuItem>
                                {branchCodes.map((branchCode) => (
                                    <MenuItem key={branchCode.id || branchCode.branchCodeId} value={branchCode.id || branchCode.branchCodeId}>
                                        {branchCode.name} ({branchCode.code})
                                    </MenuItem>
                                ))}
                            </StyledTextField>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <StyledTextField
                                fullWidth
                                name="name"
                                label="Project Name *"
                                value={formData.name}
                                onChange={handleChange}
                                variant="outlined"
                                error={!!errors.name}
                                helperText={errors.name}
                                disabled={loading}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <StyledTextField
                                fullWidth
                                name="code"
                                label="Project Code *"
                                value={formData.code}
                                onChange={handleChange}
                                variant="outlined"
                                error={!!errors.code}
                                helperText={errors.code}
                                disabled={loading}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <StyledTextField
                                fullWidth
                                name="effectiveFrom"
                                label="Effective From *"
                                type="date"
                                value={formData.effectiveFrom}
                                onChange={handleChange}
                                variant="outlined"
                                error={!!errors.effectiveFrom}
                                helperText={errors.effectiveFrom}
                                disabled={loading}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <StyledTextField
                                fullWidth
                                name="effectiveTo"
                                label="Effective To *"
                                type="date"
                                value={formData.effectiveTo}
                                onChange={handleChange}
                                variant="outlined"
                                error={!!errors.effectiveTo}
                                helperText={errors.effectiveTo}
                                disabled={loading}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <StyledTextField
                                fullWidth
                                name="totalBudget"
                                label="Total Budget"
                                type="number"
                                value={formData.totalBudget}
                                onChange={handleChange}
                                variant="outlined"
                                error={!!errors.totalBudget}
                                helperText={errors.totalBudget}
                                disabled={loading}
                                inputProps={{
                                    min: 0,
                                    step: 0.01
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <StyledTextField
                                fullWidth
                                name="remainingBudget"
                                label="Remaining Budget"
                                type="number"
                                value={formData.remainingBudget}
                                onChange={handleChange}
                                variant="outlined"
                                error={!!errors.remainingBudget}
                                helperText={errors.remainingBudget}
                                disabled={loading}
                                inputProps={{
                                    min: 0,
                                    step: 0.01
                                }}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <StyledTextField
                                fullWidth
                                name="description"
                                label="Description *"
                                value={formData.description}
                                onChange={handleChange}
                                variant="outlined"
                                multiline
                                rows={3}
                                error={!!errors.description}
                                helperText={errors.description}
                                disabled={loading}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={formData.isActive}
                                        onChange={handleChange}
                                        name="isActive"
                                        disabled={loading}
                                        sx={{
                                            color: globalColor,
                                            '&.Mui-checked': {
                                                color: globalColor
                                            }
                                        }}
                                    />
                                }
                                label="Active"
                            />
                        </Grid>

                        {editingProjectCode && (
                            <>
                                <Grid item xs={12} sm={6}>
                                    <StyledTextField
                                        fullWidth
                                        label="Created By"
                                        value={editingProjectCode.createdBy || 'N/A'}
                                        variant="outlined"
                                        InputProps={{ readOnly: true }}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <StyledTextField
                                        fullWidth
                                        label="Created At"
                                        value={editingProjectCode.createdAt 
                                            ? new Date(editingProjectCode.createdAt).toLocaleDateString('en-US', {
                                                year: 'numeric',
                                                month: 'short',
                                                day: 'numeric',
                                                hour: '2-digit',
                                                minute: '2-digit'
                                            }) 
                                            : 'N/A'}
                                        variant="outlined"
                                        InputProps={{ readOnly: true }}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <StyledTextField
                                        fullWidth
                                        label="Last Modified By"
                                        value={editingProjectCode.lastModifiedBy || 'N/A'}
                                        variant="outlined"
                                        InputProps={{ readOnly: true }}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <StyledTextField
                                        fullWidth
                                        label="Last Modified At"
                                        value={editingProjectCode.lastModifiedAt 
                                            ? new Date(editingProjectCode.lastModifiedAt).toLocaleDateString('en-US', {
                                                year: 'numeric',
                                                month: 'short',
                                                day: 'numeric',
                                                hour: '2-digit',
                                                minute: '2-digit'
                                            }) 
                                            : 'N/A'}
                                        variant="outlined"
                                        InputProps={{ readOnly: true }}
                                        disabled
                                    />
                                </Grid>
                            </>
                        )}

                        <Grid item xs={12}>
                            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                                <Button
                                    variant="outlined"
                                    startIcon={<CancelIcon />}
                                    onClick={handleCancel}
                                    disabled={loading}
                                    sx={{
                                        borderColor: globalColor,
                                        color: globalColor,
                                        '&:hover': {
                                            borderColor: globalColor,
                                            backgroundColor: `${globalColor}10`
                                        }
                                    }}
                                >
                                    Cancel
                                </Button>
                                <AnimatedButton
                                    variant="contained"
                                    startIcon={editingProjectCode ? <SaveIcon /> : <Add />}
                                    onClick={handleSubmit}
                                    disabled={loading}
                                    size="large"
                                >
                                    {loading ? 'Saving...' : (editingProjectCode ? 'Update Project Code' : 'Add Project Code')}
                                </AnimatedButton>
                            </Box>
                        </Grid>
                    </Grid>
                </CardContent>
            </StyledCard>
        </Fade>
    );
};

export default AddEditProjectCode;